import { CustomerType } from '@data/models/customer-type.interface';
import { StateCreator } from 'zustand';

export interface CustomerTypeState {
  customerTypes: CustomerType[];
  setCustomerTypes: (customerTypes: CustomerType[]) => void;
}

export const createCustomerTypeSlice: StateCreator<
  CustomerTypeState,
  [['zustand/devtools', never]],
  [['zustand/persist', never]],
  CustomerTypeState
> = (set) => ({
  customerTypes: [],
  setCustomerTypes: (customerTypes: CustomerType[]) =>
    set(() => ({ customerTypes })),
});
